// Skeleton primitives for loading states
export const SkeletonLine = ({ className = "" }) => (
  <div className={`animate-pulse bg-gradient-to-r from-zinc-100 via-zinc-200 to-zinc-100 bg-[length:200%_100%] rounded-md ${className}`} style={{ animation: "shimmer 1.4s ease-in-out infinite" }} />
);

export const SkeletonCard = ({ rows = 3 }) => (
  <div className="rounded-xl bg-white border border-zinc-100 p-5 space-y-3 shadow-sm">
    <div className="flex items-start justify-between gap-3">
      <div className="space-y-2 flex-1">
        <SkeletonLine className="h-3 w-20" />
        <SkeletonLine className="h-7 w-16" />
      </div>
      <SkeletonLine className="h-10 w-10 rounded-lg" />
    </div>
    {[...Array(rows - 1)].map((_, i) => <SkeletonLine key={i} className="h-3 w-full" />)}
  </div>
);

export const SkeletonStatGrid = ({ count = 5 }) => (
  <div className="grid grid-cols-2 lg:grid-cols-5 gap-3 sm:gap-4">
    {[...Array(count)].map((_, i) => <SkeletonCard key={i} rows={2} />)}
  </div>
);

export const SkeletonTable = ({ rows = 5, cols = 5 }) => (
  <div className="rounded-xl bg-white border border-zinc-100 shadow-sm overflow-hidden">
    <div className="border-b border-zinc-100 px-4 py-3 flex gap-4">
      {[...Array(cols)].map((_, i) => <SkeletonLine key={i} className="h-3 flex-1" />)}
    </div>
    {[...Array(rows)].map((_, r) => (
      <div key={r} className="border-b border-zinc-100 last:border-0 px-4 py-4 flex gap-4 items-center">
        {[...Array(cols)].map((_, i) => <SkeletonLine key={i} className={`h-3 flex-1 ${i === 0 ? "w-24" : ""}`} />)}
      </div>
    ))}
  </div>
);

export const SkeletonHero = () => (
  <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-indigo-100 to-purple-100 p-6 sm:p-8 animate-pulse h-32 sm:h-40" />
);
